import ReactQuill, { Quill } from 'react-quill';
import Delta from 'quill-delta';
import React, { Component, useState, useEffect } from 'react';
import { injectIntl } from 'react-intl';

import {
  PromptModal,
  BackgroundIcon,
  toast,
  getHeaderValue,
  getDownloadURL,
  ALL_MODULES,
  EventEmitter,
  getTranslatedText,
  sanitizeString,
  fetchApi
} from '@nile/components';
import { cloneDeep } from 'lodash';
import ImageResize from 'quill-image-resize-module';
import ImageUploader from 'quill-image-uploader';
import Mention from 'quill-mention';
import Conf from '@nile/home/src/Config/env';
import styled from 'styled-components';
import * as Emoji from 'quill-emoji';
import 'quill-emoji/dist/quill-emoji.css';
import 'quill-mention/dist/quill.mention.min.css';
import { Link, Spinner } from '@superops/ui-design-system';
import { SVGIcon } from '@superops/super-icons';
import ImageFormat from './ImageFormat';
import CustomToolbarGroupIcons from './EditorGroupIcons';

const fontSizeArr = [
  '1em',
  '10px',
  '11px',
  '12px',
  '13px',
  '14px',
  '15px',
  '16px',
  '17px',
  '18px',
  '19px',
  '20px',
  '21px',
  '22px',
  '23px',
  '24px'
];
const editorRef = React.createRef();

const getToolbarIcon = (type) => {
  const iconMap = {
    color: `<div style="background-image: url(${Conf.imageRoot}svg/TextColour.svg); background-size: 100%; width: 18px; height: 18px;" />`,
    bold: `<div style="background-image: url(${Conf.imageRoot}svg/Bold.svg); background-size: 100%; width: 18px; height: 18px;" />`,
    italic: `<div style="background-image: url(${Conf.imageRoot}svg/Italics.svg); background-size: 100%; width: 18px; height: 18px;" />`,
    justify: `<div style="background-image: url(${Conf.imageRoot}svg/Justify.svg); background-size: 100%; width: 18px; height: 18px;" />`,
    underline: `<div style="background-image: url(${Conf.imageRoot}svg/Underline.svg); background-size: 100%; width: 18px; height: 18px;" />`,
    align: `<div style="background-image: url(${Conf.imageRoot}svg/Alignment.svg); background-size: 100%; width: 18px; height: 18px;" />`,
    centeralign: `<div style="background-image: url(${Conf.imageRoot}svg/Center.svg); background-size: 100%; width: 18px; height: 18px;" />`,
    rightalign: `<div style="background-image: url(${Conf.imageRoot}svg/Right.svg); background-size: 100%; width: 18px; height: 18px;" />`,
    image: `<div style="background-image: url(${Conf.imageRoot}svg/Inlineimage.svg); background-size: 100%; width: 18px; height: 18px;" />`,
    link: `<div style="background-image: url(${Conf.imageRoot}svg/Link.svg); background-size: 100%; width: 18px; height: 18px;" />`,
    unorderedlist: `<div style="background-image: url(${Conf.imageRoot}svg/OrderedList.svg); background-size: 100%; width: 18px; height: 18px;" />`,
    numberedlist: `<div style="background-image: url(${Conf.imageRoot}svg/NumberList.svg); background-size: 100%; width: 18px; height: 18px;" />`,
    emoji: `<div style="background-image: url(${Conf.imageRoot}svg/Emojies.svg); background-size: 100%; width: 18px; height: 18px;" />`
  };

  return (
    iconMap[type] ||
    `<div style="background-image: url(${Conf.imageRoot}svg/Site.svg); background-size: 100%; width: 18px; height: 18px;" />`
  );
};
const AttachmentsHolder = styled.div`
  gap: 10px;
  min-height: ${(props) => (props.hasAttachments ? '60px' : '0px')};
  // border: 1px solid #ccc;
  border: none;
  border-top: none;
  padding: ${(props) => (props.hasAttachments ? '5px' : '0px')};
`;

export const AttachmentItemHolder = styled.div`
  display: inline-flex;
  background-color: #f2f2f7;
  border-radius: 8px;
  /* margin: 1rem; */
  margin-top: 0;
  word-break: break-word;
  .Polaris-Link {
    display: flex;
    align-items: center;
    padding: 1rem;
    padding-right: 0.2rem;
  }
  &:hover {
    cursor: pointer;
  }
  .close-action {
    border-radius: 0 8px 8px 0;
    padding: 1rem;
    display: flex;
    align-items: center;
    &:hover {
      background-color: #ffbdad;
      color: #de350b;
    }
  }
`;

const QuillWrapper = styled.div`
  .ap {
    background-image: url(${Conf.imageRoot}emojis.webp);
  }

  .ql-snow .ql-picker.ql-expanded .ql-picker-options,
  .ql-snow .ql-picker .ql-toolbar.ql-snow {
    top: auto;
    bottom: 100%;
    overflow: auto;
  }

  .ql-snow .ql-picker.ql-expanded.ql-size .ql-picker-options,
  .ql-snow .ql-picker .ql-toolbar.ql-snow {
    height: 150px;
  }

  .ql-toolbar {
    ${(props) => (props?.hideToolbar ? 'display: none !important;' : '')}
  }

  .ql-toolbar.ql-snow .ql-active {
    background-color: rgba(0, 0, 0, 0.1) !important;
    border-radius: 4px;
  }

  .ql-toolbar > button,
  .ql-toolbar > span {
    margin: 0 2px;
  }

  .ql-toolbar > span:first-child {
    margin: 0 2px 0 0;
  }
`;

const AttachmentItem = ({
  fileName,
  originalFileName,
  handleAttachmentsDeletion,
  template,
  module: parentModule,
  disableDownload
}) => {
  const module = parentModule || ALL_MODULES.notificationTemplateAttachment;
  const details = {
    fileName: fileName
  };

  switch (module) {
    case ALL_MODULES.notificationTemplateAttachment:
      details.templateId = template?.id;
      details.type = template?.templateType;
      break;
    case 'PROJECT_TEMPLATE_ATTACHMENT':
      details.projectTemplateId = template?.id;
      break;
    default:
      break;
  }
  const url = getDownloadURL({ module, details });

  return (
    <AttachmentItemHolder>
      <Link url={!disableDownload && url} removeUnderline>
        {originalFileName}
      </Link>
      <div
        className="close-action"
        onClick={() => handleAttachmentsDeletion(fileName)}
      >
        x
      </div>
    </AttachmentItemHolder>
  );
};

const AddAttachments = (props) => {
  const handleFileAttachments = (files) => {
    props.handleFileAttachments(files);
  };
  return (
    <PromptModal
      id="addAttachmentsBtn"
      description="Upload/drop files here"
      handleSubmit={handleFileAttachments}
      title="Add attachments"
      noIcon
      svg={
        /* Editor icons hence not changed to SVG */
        <SVGIcon name="FileAttachment" color="#323232" />
      }
      link
      allowMultiple
      acceptAllType={props?.acceptAllType}
      acceptType={props?.acceptType}
    />
  );
};

let hashValues = [
  { id: 3, value: 'Fredrik Sundqvist 2' },
  { id: 4, value: 'Patrik Sjölin 2' }
];

let mentionValues = [
  { id: 1, value: 'Harsha Vardhan' },
  { id: 2, value: 'H V' }
];

let module = 'PROJECT';
// let details = JSON.stringify({ operation: 'UPDATE' });
let details;
let envConfig = Conf;
let CustomToolbarComponent;

function insertAttachments() {
  const cursorPosition = this.quill.getSelection().index;
  this.quill.insertText(cursorPosition, '★');
  this.quill.setSelection(cursorPosition + 1);
}

function insertField(value) {
  const cursorPosition = this.quill.getSelection().index;
  this.quill.insertText(cursorPosition, value);
  this.quill.setSelection(cursorPosition + value.length);
}

const CustomToolbar = (props) => (
  <div id={`toolbar${props?.randomToolbarKey}`}>
    {/* <select className="ql-font" /> */}
    <select className="ql-size">
      <option value="1em" selected>
        Default
      </option>
      <option value="10px">10px</option>
      <option value="11px">11px</option>
      <option value="12px">12px</option>
      <option value="13px">13px</option>
      <option value="14px">14px</option>
      <option value="15px">15px</option>
      <option value="16px">16px</option>
      <option value="17px">17px</option>
      <option value="18px">18px</option>
      <option value="19px">19px</option>
      <option value="20px">20px</option>
      <option value="21px">21px</option>
      <option value="22px">22px</option>
      <option value="23px">23px</option>
      <option value="24px">24px</option>
    </select>
    {/* <select className="ql-header" /> */}
    <select className="ql-color" />
    <button className="ql-bold" />
    <button className="ql-italic" />
    <button className="ql-underline" />
    <select className="ql-align" />
    <button className="ql-list" value="bullet" />
    <button className="ql-list" value="ordered" />
    {props?.showInlineImage && <button className="ql-image" />}
    <button className="ql-link" />
    <button className="ql-emoji">
      {/* Editor icons hence not changed to SVG */}
      <BackgroundIcon url={`url(${Conf.imageRoot}svg/Emojies.svg)`} />
    </button>
    {props?.handleFileAttachments && <AddAttachments {...props} />}
  </div>
);
class RTEditor extends Component {
  randomToolbarKey = Math.floor(Math.random() * 1000);

  modules = {
    toolbar: {
      container: `#toolbar${this.randomToolbarKey}`,
      handlers: {
        insertAttachments: insertAttachments,
        insertField: insertField,
        emoji: function() {}
      }
    },
    clipboard: {
      matchVisual: false
    },
    imageResize: {},
    'emoji-toolbar': {
      buttonIcon: getToolbarIcon('emoji')
    },
    // 'emoji-textarea': true,
    'emoji-shortname': true,
    mention: {
      allowedChars: /^[A-Za-z\sÅÄÖåäö]*$/,
      positioningStrategy: 'fixed',
      mentionDenotationChars: ['#', '@'],
      source: function(searchTerm, renderList, mentionChar) {
        let values = hashValues;
        if (mentionChar === '@') {
          values = mentionValues;
        }

        if (searchTerm.length === 0) {
          renderList(values, searchTerm);
        } else {
          const matches = [];
          for (let i = 0; i < values.length; i++)
            if (
              !values[i].value.toLowerCase().indexOf(searchTerm.toLowerCase())
            )
              matches.push(values[i]);
          renderList(matches, searchTerm);
        }
      },
      onSelect: (item, insertItem) => {
        insertItem(item);
      }
    },
    imageUploader: {
      upload: (file) => {
        return new Promise((resolve, reject) => {
          const formData = new FormData();
          formData.append('image', file);
          formData.append('module', this.module || module);
          formData.append('details', this.details || details);

          if (!details) {
            reject('Upload failed');
            toast('warning', 'Select client to upload file');
            return null;
          }

          const requestOptions = {
            method: 'POST',
            credentials: 'include',
            body: formData,
            headers: this.props.customHeaderValue || getHeaderValue()
          };

          const getModuleURL = () => {
            switch (module) {
              /* case 'PROJECT':
              case 'PROJECT_COMMENT':
              case 'PROJECT_TASK':
              case 'TICKET':
              case 'TICKET_CONVERSATION':
              case 'TICKET_NOTE':
              case 'TICKET_TASK':
              case 'TASK_TEMPLATE':
              case 'REPLY_TEMPLATE':
                return `${envConfig.ticketingRoot}/inline_images`; */
              default:
                return `${envConfig.fileRoot}/inline_images`;
            }
          };

          EventEmitter.dispatch('imageUploading', true);
          fetchApi(getModuleURL(), requestOptions)
            .then((response) => {
              return response.json();
            })
            .then((result) => {
              const existingImages = this.state.inlineImages || [];
              this.setState({
                inlineImages: existingImages.includes(result.data.fileName)
                  ? existingImages
                  : existingImages.concat(result.data.fileName)
              });
              resolve(`${result.data.link}`);
            })
            .catch((error) => {
              reject('Upload failed');
            })
            .finally(() => EventEmitter.dispatch('imageUploading', false));
        });
      }
    }
  };

  constructor(props) {
    super(props);
    Quill.register(ImageFormat, true);
    // Quill.register(CustomBlockQuote);
    // Quill.register('formats/blockquote', CustomBlockQuote);
    Quill.register('modules/imageUploader', ImageUploader);
    Quill.register('modules/imageResize', ImageResize);
    Quill.register('modules/emoji', Emoji);
    Quill.register('modules/mention', Mention);
    const icons = Quill.import('ui/icons');
    const Size = Quill.import('attributors/style/size');
    const AlignStyle = Quill.import('attributors/style/align');
    // const BlockQuote = Quill.import('formats/blockquote');

    Size.whitelist = fontSizeArr;
    Quill.register(AlignStyle, true);
    Quill.register(Size, true);

    icons['bold'] = getToolbarIcon('bold');
    icons['italic'] = getToolbarIcon('italic');
    icons['underline'] = getToolbarIcon('underline');
    icons['color'] = getToolbarIcon('color');
    icons['image'] = getToolbarIcon('image');
    icons['align'][''] = getToolbarIcon('align');
    icons['align']['center'] = getToolbarIcon('centeralign');
    icons['align']['right'] = getToolbarIcon('rightalign');
    icons['align']['justify'] = getToolbarIcon('justify');
    icons['list']['ordered'] = getToolbarIcon('numberedlist');
    icons['list']['bullet'] = getToolbarIcon('unorderedlist');
    icons['link'] = getToolbarIcon('link');
    icons['emoji'] = getToolbarIcon('emoji');
    this.state = {
      editorHtml: props?.template?.content || '',
      placeholdersUsed: props?.template?.placeholdersUsed || '{}',
      mentions: props?.template?.mentions || [],
      attachments: props?.template?.attachmentList || [],
      inlineImages: props?.template?.inlineImages || [],
      lastCursorRange: {}
    };
  }

  componentDidMount() {
    const editorLength = editorRef.current?.editor?.getLength();
    if (editorLength === 1 && this.props.focusEditor) {
      editorRef.current?.editor?.focus();
    }

    EventEmitter.subscribe('insertEditorContent', this.handleInsertContent);
    EventEmitter.subscribe('replaceEditorContent', this.replaceSelectedContent);
  }

  componentDidUpdate(prevProps) {
    if (prevProps?.template?.content !== this.props?.template?.content) {
      this.setState({
        editorHtml: this.props?.template?.content
      });
    }
    // Ideally we need to have only a single source of truth. Pushing this for L2 fix.
    // Mathangi is working on cleaning this component states.
    // Everything will come from props.
    if (
      !this.props?.allowPlaceholdersUpdate &&
      prevProps?.template?.placeholdersUsed &&
      this.props?.template?.placeholdersUsed !==
        prevProps?.template?.placeholdersUsed
    ) {
      this.setState({
        placeholdersUsed: this.props?.template?.placeholdersUsed || '{}'
      });
    }

    if (
      this.props?.allowPlaceholdersUpdate &&
      this.props?.template?.placeholdersUsed !==
        prevProps?.template?.placeholdersUsed
    ) {
      this.setState({
        placeholdersUsed: this.props?.template?.placeholdersUsed || '{}'
      });
    }
    if (
      prevProps?.template?.mentions &&
      JSON.stringify(this.props?.template?.mentions) !==
        JSON.stringify(prevProps?.template?.mentions)
    ) {
      this.setState({
        mentions: this.props?.template?.mentions
      });
    }
  }

  componentWillUnmount() {
    EventEmitter.unsubscribe('insertEditorContent');
    EventEmitter.unsubscribe('replaceEditorContent');
    const openPopup = document.getElementsByClassName(
      'ql-mention-list-container'
    );
    if (openPopup?.length) {
      document.body.removeChild(openPopup[0]);
    }
  }

  /**
   *
   * @param {HTMLString} contentToAppend
   * @description
   * Normal string replace won't work here.
   * Use delta object to create old delta and append it to the current delta to retain the
   * old elements before cursor.
   * updateContents and setSelection has the 'user' and 'silent' arguments to know how the change is made, so they call respective methods.
   */
  handleInsertContent = (contentToAppend) => {
    const { lastCursorRange } = this.state;
    const newDelta = editorRef.current.editor.clipboard.convert(
      contentToAppend
    );
    const deltaCond = [];
    if (lastCursorRange.index > 1) {
      deltaCond.push({
        retain: lastCursorRange.index
      });
    }
    const oldDelta = new Delta(deltaCond);

    const delta = oldDelta.concat(newDelta);
    editorRef.current.editor.updateContents(delta, 'user');
    editorRef.current.editor.setSelection(
      delta.length() - lastCursorRange.length,
      'silent'
    );
    editorRef.current.editor.focus();
  };

  replaceSelectedContent = (newContent) => {
    const editor = editorRef.current.getEditor(); // Get the Quill instance
    const range = editor.getSelection(); // Get the current selection range
    if (range) {
      editor.deleteText(range.index, range.length); // Remove selected text
      editor.clipboard.dangerouslyPasteHTML(range.index, newContent); // Replace with new HTML
    } else {
      this.handleInsertContent(newContent);
    }
  };

  handleChange = (html, deltaChange) => {
    const delta = deltaChange.filter((del) => !!del.insert?.mention);
    let updatedPlaceholders = this.state?.placeholdersUsed;
    let updatedMentions = cloneDeep(this.state?.mentions || []);
    delta.forEach((del) => {
      const item = del.insert.mention;
      if (item?.denotationChar === '#') {
        if (updatedPlaceholders) {
          updatedPlaceholders = JSON.parse(updatedPlaceholders);
          if (!updatedPlaceholders.content) {
            updatedPlaceholders.content = {};
          }
          if (!updatedPlaceholders.content[item.id]) {
            updatedPlaceholders.content[item.id] = item.value;
          }
          updatedPlaceholders = JSON.stringify(updatedPlaceholders);
        }
      }

      if (item?.denotationChar === '@') {
        if (updatedMentions) {
          // To add only once in mentions list
          if (!updatedMentions.find((ment) => ment?.userId === item.id)) {
            updatedMentions = [...updatedMentions, ...[{ userId: item.id }]];
          }
        }
      }
    });

    let dummyDiv = document.createElement('div');
    dummyDiv.innerHTML = html;
    const mentionedItems = Array.from(
      new Set(
        Array.from(
          dummyDiv.querySelectorAll(
            'span.mention[data-id][data-denotation-char="@"]'
          )
        ).map((item) => item.getAttribute('data-id'))
      )
    );

    const mentionedPlaceholders = [];

    const translatedMentionedPlaceholders = Array.from(
      dummyDiv.querySelectorAll(
        'span.mention[data-id][data-denotation-char="#"]'
      )
    ).reduce((acc, node) => {
      /*
       * A node can either be a `Custom Field` or `Translatable placeholders`
       * Note: Custom fields doesn't need to be translated
       */
      const localeId = node.getAttribute('data-id');

      const translatedValue = getTranslatedText(this.props.intl, localeId);

      /* Replacing the placeholders resolved values with current selected lang */

      // eslint-disable-next-line no-restricted-syntax
      for (const subNode of Array.from(
        node.querySelector('[contenteditable="false"]').childNodes
      )) {
        // Should translate only the placeholder text inside the node without losing the `#`
        if (subNode.nodeName === '#text') {
          // Placeholder rendered text is present inside `TextNode`.`#text` refers to `TextNode`
          // eslint-disable-next-line no-param-reassign
          if (localeId.includes('udf')) {
            // Skip for custom field
            if (!acc[localeId]) {
              // Push only once if `localeId` i.e placeholder is repeated
              mentionedPlaceholders.push(localeId);
            }
            acc[localeId] = subNode.textContent;
            return acc;
          }
          subNode.textContent = translatedValue;
        }
      }

      if (node.getAttribute('data-value')) {
        // Replace the content in `data-value` attribute
        node.setAttribute('data-value', translatedValue);
      }
      if (!acc[localeId]) {
        // Push only once if `localeId` i.e placeholder is repeated
        mentionedPlaceholders.push(localeId);
      }
      acc[localeId] = translatedValue;
      return acc;
    }, {});

    updatedPlaceholders = JSON.parse(updatedPlaceholders);
    updatedPlaceholders.content = translatedMentionedPlaceholders;
    updatedPlaceholders = JSON.stringify(updatedPlaceholders);

    const finalMentions = updatedMentions.filter((item) =>
      mentionedItems.includes(item?.userId)
    );
    const placeholderContentCopy = JSON.parse(updatedPlaceholders);
    if (placeholderContentCopy?.content)
      Object.keys(JSON.parse(updatedPlaceholders).content).forEach(
        (placeholder) => {
          if (!mentionedPlaceholders.includes(placeholder))
            delete placeholderContentCopy.content[placeholder];
        }
      );

    this.props.updateTemplate({
      // content: sanitizeString(html),
      content: this.props.translateInnerHtml ? dummyDiv.innerHTML : html,
      placeholdersUsed: JSON.stringify(placeholderContentCopy),
      mentions: finalMentions,
      inlineImages: this.state.inlineImages
    });
    dummyDiv = null;
  };

  handleKeyPress = (event) => {
    if (event?.key === 'Enter') {
      const editorContainerHeight =
        document.getElementById('quill-rt-editor')?.getBoundingClientRect()
          ?.height - 40;
      const cursorPosition = editorRef.current?.editor?.getSelection();
      const cursorCoordinates = editorRef.current?.editor?.getBounds(
        cursorPosition
      );

      if (
        editorContainerHeight < cursorCoordinates?.bottom &&
        this.props?.scrollIntoView
      ) {
        this.props.scrollIntoView();
      }
    }
  };

  render() {
    const {
      placeholder,
      fields,
      userMentions,
      module: parentModule,
      details: parentDetails,
      attachmentModule,
      template,
      handleAttachmentsDeletion,
      disabled,
      isUploading,
      groupedIcon
    } = this.props;
    const { editorHtml } = this.state;
    hashValues = fields || [];
    mentionValues = userMentions || [];
    module = parentModule;
    this.module = parentModule;
    details = parentDetails ? JSON.stringify(parentDetails) : null;
    this.details = parentDetails ? JSON.stringify(parentDetails) : null;
    envConfig = envConfig;
    CustomToolbarComponent = this.props?.customToolbarComponent;
    // if (fields && !fields?.length) {
    // if (!isLoaded) {
    //   return <div>Loading..</div>;
    // }
    // console.log(Quill.imports);
    return (
      <QuillWrapper
        className="text-editor"
        id="quill-rt-editor"
        hideToolbar={this.props?.hideToolbar}
      >
        <ReactQuill
          ref={(node) => {
            editorRef.current = node;
            // setting ref directly in the parent and removing the setInstance state.
            if (
              this.props?.editorRef &&
              this.props.editorRef.hasOwnProperty('current')
            ) {
              this.props.editorRef.current = node;
            }
          }}
          placeholder={placeholder}
          value={template?.content || editorHtml}
          formats={RTEditor.formats}
          modules={this.modules}
          onChange={this.handleChange}
          readOnly={disabled}
          onKeyUp={this.handleKeyPress}
        />
        {template?.attachmentList && (
          <AttachmentsHolder
            className="flex wrap"
            hasAttachments={template?.attachmentList.length > 0}
          >
            {template?.attachmentList.map((attachment) => (
              <AttachmentItem
                fileName={attachment?.fileName}
                originalFileName={attachment?.originalFileName}
                fileSize={attachment?.fileSize}
                handleAttachmentsDeletion={handleAttachmentsDeletion}
                template={template}
                module={attachmentModule}
              />
            ))}
          </AttachmentsHolder>
        )}
        {template?.attachments && (
          <AttachmentsHolder
            className="flex wrap"
            hasAttachments={template?.attachments.length > 0}
          >
            {template?.attachments.map((attachment) => (
              <AttachmentItem
                fileName={attachment?.fileName}
                originalFileName={attachment?.originalFileName}
                fileSize={attachment?.fileSize}
                handleAttachmentsDeletion={handleAttachmentsDeletion}
                template={template}
                module={attachmentModule}
                disableDownload={
                  module !== 'NOTIFICATION_TEMPLATE' ||
                  module !== 'TICKET_NOTIFICATION_TEMPLATE' ||
                  module !== 'ON_BOARDING_NOTIFICATION_TEMPLATE' ||
                  module !== 'REPLY_TEMPLATE' ||
                  module !== 'PROJECT_TEMPLATE'
                }
              />
            ))}
          </AttachmentsHolder>
        )}
        {isUploading && (
          <div className="ml-20">
            <Spinner
              accessibilityLabel="Small spinner example"
              size="small"
              color="inkLightest"
            />
          </div>
        )}

        {CustomToolbarComponent ? (
          <>
            <div>
              <div
                id={`toolbar${this.randomToolbarKey}`}
                className="ql-toolbar"
              >
                <CustomToolbarComponent />
              </div>
            </div>
          </>
        ) : (
          <>
            {groupedIcon ? (
              <CustomToolbarGroupIcons
                {...this.props}
                randomToolbarKey={this.randomToolbarKey}
                singleAttachment={this.props?.singleAttachment}
              />
            ) : (
              <CustomToolbar
                {...this.props}
                randomToolbarKey={this.randomToolbarKey}
                singleAttachment={this.props?.singleAttachment}
              />
            )}
          </>
        )}
      </QuillWrapper>
    );
  }
}

RTEditor.formats = [
  'header',
  'font',
  'size',
  'bold',
  'italic',
  'underline',
  'strike',
  'blockquote',
  'list',
  'bullet',
  'ordered',
  'align',
  'indent',
  'link',
  'image',
  'imageBlot',
  'color',
  'emoji',
  'mention',
  'width',
  'style',
  'data-index',
  'data-denotation-char',
  'data-id',
  'data-value'
];

export default injectIntl(RTEditor);
